module.exports = __webpack_public_path__ + "assets/b8d3731e2c2e0f8597ccf3d6b0b235ea.png";